export default {
  newVersionOf: 'Nueva versión de',
  versionNotes: 'Notas de la versión',
  versionNotesPlaceholder: 'p. ej. Se agrega un año de datos nuevos a la versión anterior',
  noPreviousVersion: 'Deja el campo vacío si este modelo no tiene una versión anterior',
  willBeVersion: 'Este modelo será la v{version} de {name}',
  isVersion: 'Este modelo es la v{version}. Borra el campo para desenlazarlo',
  notLatest: 'Este modelo es la v{version}. Solo se puede desenlazar la última versión de una familia',
  hasOwnVersions: 'Este modelo es la primera versión de su propia familia, así que no puede ser versión de otro modelo'
}
